  <template>
    <div v-if="loader.loading.value" class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50" style="z-index: 99999;">
      <div class="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
    </div>
  </template>
  
  <script setup>
  import { useLoaderStore } from '../shared/store/loader';
  import { storeToRefs } from "pinia";
  
  const loader = storeToRefs(useLoaderStore()); // Acessa o store corretamente
  </script>
  